<div class="main-card mb-3 card">
  <div class="card-header font-weight-B fs-1r">Qr Configration</div>
  <div class="tab-content" id="nav-tabContent">
    <div
      class="tab-pane fade show active"
      id="pending"
      role="tabpanel"
      aria-labelledby="pending-tab"
    >
      <div class="table-responsive">
        <table
          class="align-middle mb-0 table table-borderless table-striped table-hover"
          id="excel-table"
        >
          <thead>
            <tr>
        
              <th>mode</th>
              <th>mc</th>
              <th>qrMedium</th>
              <th>tn</th>
              <th>pn</th>
              <th>pa</th>
              <th>Created On</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of allQrConfig">
              
              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">{{ data.mode }}</div>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">{{ data.mc }}</div>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">{{ data.qrMedium }}</div>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">{{ data.tn }}</div>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">{{ data.pn }}</div>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">{{ data.pa }}</div>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">{{ data.createdOn }}</div>
                    </div>
                  </div>
                </div>
              </td>
              <td class="text-end">
                <div class="dropdown">
                  <button
                    class="btn btn-info dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Action
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
          <!-- <div *ngIf="allDriverPartner_PendingRequests?.length  == 0" class="text-center mt-5 mb-5" >
          <span class="text-danger">Data Not found</span>
        </div> -->
        </table>
        <!-- <pagination-controls class="my-pagination" (pageChange)="gty_Pending((page_Pending = $event))"></pagination-controls> -->
      </div>
    </div>
  </div>
</div>
